//
import type { IHomeStore } from './homeStore.model';

export const getDefaultState = (): IHomeStore => ({
  mfaToken: 'some-initialized-token',
  loading: false,
});

const state = getDefaultState();

export default state;
